import { render, staticRenderFns } from "./mainClassification.vue?vue&type=template&id=4dfc6201"
import script from "./mainClassification.vue?vue&type=script&lang=js"
export * from "./mainClassification.vue?vue&type=script&lang=js"
import style0 from "./mainClassification.vue?vue&type=style&index=0&id=4dfc6201&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports